import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Proof() {
  return <section className="py-24 bg-heritage-terracotta text-heritage-cream relative overflow-hidden" data-id="element-155">
      {/* Decorative texture */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-heritage-gold to-transparent" data-id="element-156"></div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-157">
        <FadeIn data-id="element-158">
          <p className="font-script text-3xl md:text-4xl text-heritage-gold mb-8" data-id="element-159">
            Imagina esto...
          </p>

          <blockquote className="font-serif text-2xl md:text-4xl leading-relaxed mb-10" data-id="element-160">
            "Dentro de 20 años, tu nieta podrá cocinar tu plato estrella y el
            aroma en su casa será exactamente el mismo que hay hoy en la tuya.
            Sentirá que estás ahí, guiando sus manos."
          </blockquote>

          <p className="text-xl md:text-2xl font-medium text-heritage-beige" data-id="element-161">
            Eso no tiene precio, pero{' '}
            <span className="italic underline decoration-heritage-gold underline-offset-4" data-id="element-162">
              sí tiene un método.
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}